export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14797.1a33af57.jpg";